import { getSignalRConnector } from '@/api/signalR/SignalRConnector.ts';
import { connectionStatusToString } from '@/api/signalR/worker/messages/WorkerSentMessage.ts';
import { logger } from '@/components/SgwtBootstrap/logger.ts';
import { getConfig } from '@/config/config.ts';
import { store } from '@/store/store.ts';
import { streamingSlice } from '@/store/streaming/slice.ts';

export function startWorker(userEmail: string, sgConnectToken: string) {
  const signalRConnector = getSignalRConnector();

  signalRConnector.onConnectionStatusUpdate((message) => {
    logger.logInformation('Connection status {connection_status_s}', connectionStatusToString(message));
    store.dispatch(streamingSlice.actions.signalRStatusUpdated(message));
  });

  const { app: appConfig, frontVersion } = getConfig();

  signalRConnector.start({
    apiUrl: appConfig.apiUrl,
    signalRConfig: appConfig.signalR,
    userEmail,
    sgConnectToken,
    frontVersion,
    workerConfig: appConfig.worker,
  });

  signalRConnector.beginPullLoop();
}
